import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Enums,
  HuntPackageRecord,
  HuntSummary,
} from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../tracking/tracking.service';

@Injectable({
  providedIn: 'root',
})
export class HuntPackageService {
  constructor(
    private httpClient: HttpClient,
    private trackingService: TrackingService,
  ) {}

  public getHuntPackageByUUID = (
    uuid: string,
  ): Observable<HuntPackageRecord> => {
    return this.httpClient.get<HuntPackageRecord>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}`,
    );
  };

  public getHuntPackagesbyUUIDs(
    uuids: Array<string>,
  ): Observable<Array<HuntPackageRecord>> {
    const searchParams: { [param: string]: string | string[] } = { uuids };
    return this.httpClient.get<Array<HuntPackageRecord>>(
      `${environment.api}/es/cyborg-hunt-package/list/`,
      {
        params: searchParams,
      },
    );
  }

  public getRelatedHunts = (uuid: string): Observable<Array<HuntSummary>> => {
    return this.httpClient.get<Array<HuntSummary>>(
      `${environment.api}/es/cyborg-hunt-package/${uuid}/related-hunts`,
    );
  };

  public getHuntPackageValidation(uuid: string, filename: string): void {
    this.httpClient
      .get(`${environment.api}/es/cyborg-hunt-package/${uuid}/validation`, {
        responseType: 'blob',
      })
      .subscribe((data: Blob) => {
        const tempUrl = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.setAttribute('href', tempUrl);
        a.setAttribute('type', 'hidden');
        a.setAttribute('download', filename + ' - AtomicValidation.zip');
        document.body.appendChild(a);
        a.click();
        a.remove();
      });

    this.trackingService.trackEvent(
      TrackingEventEnum.RESEARCH_VALIDATION_PACKAGE_DOWNLOADED,
      {
        UUID: uuid,
        filename,
      },
    );
  }

  public getRelatedHuntPackages(
    terms: Array<string>,
  ): Observable<Array<HuntPackageRecord>> {
    return this.httpClient.get<Array<HuntPackageRecord>>(
      `${
        environment.api
      }/es/cyborg-hunt-package/threat-profile-query?term=${terms.join(',')}`,
    );
  }

  public getPopularHuntPackages = (): Observable<HuntPackageRecord[]> => {
    return this.httpClient.get<HuntPackageRecord[]>(
      `${environment.api}/es/popular/${Enums.CyborgIndexEnum.CYBORG_USE_CASES}?size=3`,
    );
  };

  public getRecentHuntPackages = (
    size: number,
  ): Observable<Array<HuntPackageRecord>> => {
    return this.httpClient.get<HuntPackageRecord[]>(
      `${environment.api}/es/cyborg-hunt-package/summary/recently-updated?size=${size}`,
    );
  };

  public getMITREAggregations = (): Observable<Record<string, unknown>> => {
    return this.httpClient.get<Record<string, unknown>>(
      `${environment.api}/es/cyborg-hunt-package/summary/mitre-aggregation`,
    );
  };
}
